<template>
	<c-modal @close="close" :title="'Verwijderen?'">
		<div>
			<p class="margin-t-32">Weet je zeker dat je deze contactpersoon definitief wilt verwijderen?</p>

			<c-button class="c-btn--hollow c-btn--expanded margin-t-32 margin-b-16" @click="removeContact()">
				Ja, contactpersoon verwijderen
			</c-button>

			<c-button class="c-btn--expanded no-margin-b" @click="close()">
				Nee, contactpersoon behouden
			</c-button>
		</div>
	</c-modal>
</template>

<script>
import CModal from '@components/Modal';
import Form from '@mixins/Form';

export default {
	mixins: [Form],
	components: {
		CModal
	},
	props: {
		contact: {
			required: false
		}
	},
	data() {
		return {
			text: '',
			cantDelete: false,
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		removeContact(){
            this.$xhr.delete('/api/contacts/' + this.contact.id).then( ( {result}) => {
				this.$store.dispatch('toast/success', {title: 'Contactpersoon verwijderen', text: 'De contactpersoon is verwijderd'});
                this.$emit('close:confirm')
                this.close();
			}).catch( (e) => {
                    this.$store.dispatch('toast/alert', {title: 'Contactpersoon verwijderen', text: 'Er is helaas iets fout gegaan bij het verwijderen'});
			});
		}
	},
}
</script>
